import { render, staticRenderFns } from "./LockIcon.vue?vue&type=template&id=b33f4d18"
import script from "./LockIcon.vue?vue&type=script&lang=js"
export * from "./LockIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports